import '../scss/main.scss';

import SituationMap from './situatiekaart';

window.SituatieKaart = SituationMap;